/*
 * Created by alex@hackerbay.com on 21.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../components/Header";
import TextBody from "../components/TextBody";
import {Col, Container, Input, Row} from "reactstrap";
import vodafoneLogo from "../media/icons/vf-logo.png";
import iconWarning from "../media/icons/warning.png";
import {SpacerRow} from "../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";

class ServerError extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const vodafoneLogoImage = <img src={vodafoneLogo} className={"img-fluid"} alt={"vodafone logo"}/>;
        const errorTextContent = <div>
            <Header
                textResource={"server_error_title"}
            />
            <SpacerRow/>
            <TextBody
                textResource={"server_error_body"}
            />
        </div>;

        const warningIconImage = <center><img src={iconWarning} style={{width:"120px",height:"110px"}} alt={"warning icon"} /></center>;

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        {vodafoneLogoImage}
                    </Col>
                </Row>
                <SpacerRow/>
                {errorTextContent}
                <Row style={{marginTop:"33%"}}>
                    <Col>
                        {warningIconImage}
                    </Col>
                </Row>
            </MobileView>
            <BrowserView>
                <Row style={{paddingTop:"25vh"}}>
                    <Col xs={{ size: 5, offset: 2 }}>
                        {errorTextContent}
                    </Col>
                    <Col xs={{ size: 4 }} style={{marginTop:"12px"}}>
                            {warningIconImage}
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(ServerError);